












































import { FeedbackHttp } from "@/mixins/http/feedback";
import { Component, Mixins, Watch } from "vue-property-decorator";

@Component
export default class FeedbackPopup extends Mixins(FeedbackHttp) {
	feedback: string = "";
	sendingFeedback: boolean = false;
	showPopup: boolean = false;
	showSucessMessage: boolean = false;

	attemptSendFeedback(): void {
		this.sendingFeedback = true;
		if (this.feedback && this.feedback != "") {
			this.sendFeedback(this.feedback)
				.then(() => {
					this.showSucessMessage = true;
				})
				.finally(() => {
					this.sendingFeedback = false;
					this.feedback = "";
				});
		}
	}

	@Watch("showPopup")
	showPopupChanged(opened: boolean): void {
		if (!opened) {
			this.resetPopupVariables();
		}
	}

	resetPopupVariables(): void {
		this.feedback = "";
		this.sendingFeedback = false;
		this.showSucessMessage = false;
	}
}
